const dev = {
  url: {
    apiEndPoint: "http://localhost:8181/api",
    urlLogout: "http://localhost:3000/logout"
  }
};
const bomFuturo = {
  url: {
    apiEndPoint: "https://matogrossoenergia.rzkenergia.net/api",
    urlLogout: "https://matogrossoenergia.rzkenergia.net/logout"
  }
};
const areaClienteDemo = {
  url: {
    apiEndPoint: "https://areaclientedemo.acessoenergia.com.br/api",
    urlLogout: "https://areaclientedemo.acessoenergia.com.br/logout"
  }
};
const rzkProd = {
  url: {
    apiEndPoint: "https://rzk.acessoenergia.com.br/api",
    urlLogout: "https://rzk.acessoenergia.com.br/logout"
  }
};
const devDocker = {
  url: {
    apiEndPoint: "http://172.17.0.2:8181/api",
    urlLogout: "http://172.17.0.2:3000/logout",
    urlUpload: "http://172.17.0.2:8181/api"
  }
};
const ambienteHomologacaoRZK = {
  url: {
    apiEndPoint:
      "https://homologacao-area-cliente-rzk.acessoenergia.com.br/api",
    urlLogout:
      "https://homologacao-area-cliente-rzk.acessoenergia.com.br/logout"
  }
};
const ambienteBRZPROD = {
  url: {
    apiEndPoint: "https://area-cliente-brz.acessoenergia.com.br/api",
    urlLogout: "https://area-cliente-brz.acessoenergia.com.br/logout"
  }
};

const ambienteLocalhost = {
  url: {
    apiEndPoint: "https://brz.acessoenergia.com.br/api",
    urlLogout: "http://localhost:3000/logout"
  }
};
export const config = ambienteBRZPROD;
